module.exports = __webpack_public_path__ + "static/J2026_SNML_abs-8eb8373cba98a61720a15a9a2fe34832.png";